import { divide } from "lodash";
import React, { Component } from "react";
import { Divider } from "semantic-ui-react";
import { List, Button, Icon, Table, Message, Form, Modal, Header, Pagination, Dropdown, Select, Input } from 'semantic-ui-react'
import config from "../config";
import LoadingPage from "./LoadingPage"
import  { invokeApig, downloadS3Text, uploadS3Text } from "../libs/awsLib";
import { JSONDate, exportToExcel, formatDate } from "../libs/sharedFunctions";
import ReactJson from 'react-json-view'
import { Link} from "react-router-dom";
import qs from 'qs';
import _ from 'lodash';


const NO_PAGES=100;


export default class SmartDetailReport extends Component {
  constructor(props) {
    super(props);
  
    const today=new Date();
    var startDate=new Date();
    startDate.setDate(today.getDate() - 1)
    var endDate=new Date();

    this.state = {
      reportData: [], 
      reportParameters: this.props.reportdefinition.parameterDefaults, 
      activePage: 1, 
      reportLoading: false, 
      savedReports: [], 
      savedReportName: '', 
      errorMessage: null,
      errorDetail: []
      };
  

  
 }

 componentDidMount ()
  {
    this.loadSavedReports(this.props.reportdefinition.reportName);
  }

componentWillReceiveProps(nextProps) {
  if (nextProps.reportdefinition.reportName!==this.props.reportdefinition.reportName)
  {
    
    this.setState({reportData: [], reportParameters: nextProps.reportdefinition.parameterDefaults});
    this.loadSavedReports(nextProps.reportdefinition.reportName);
    
  }
}

loadSavedReports(reportName)
{
  const bucket=config.awsEnv+'.sgserve.config';
  const key=config.stage+'/smartreports-'+reportName+'.json';
  downloadS3Text(bucket, key).then(result=>{this.setState({savedReports: _.sortBy(result, 'name')})}).catch(err=>{this.setState({savedReports: []})});
}

saveReport() {
  //load latest reporty definitions
  const bucket=config.awsEnv+'.sgserve.config';
  const key=config.stage+'/smartreports-'+this.props.reportdefinition.reportName+'.json';
  var savedReports;
  downloadS3Text(bucket, key).then(result=>{
    savedReports=result;
    //see if report already exists
    var reportIndex=savedReports.findIndex(report=>{return report.name===this.state.savedReportName});
    if (reportIndex>=0)
    {
      savedReports[reportIndex]={name: this.state.savedReportName, parameters: this.state.reportParameters};
    }
    else
    {
      savedReports.push({name: this.state.savedReportName, parameters: this.state.reportParameters});
    }
  }).catch(()=>{savedReports=[{name: this.state.savedReportName, parameters: this.state.reportParameters}]}).then(()=>{uploadS3Text(bucket, key, savedReports)}).then(result=>{this.setState({showSaveModal: false, savedReports: savedReports})});


}

loadReportData=()=>
{
  this.setState({reportLoading: true, errorMessage: null, errorDetail: []})
  var parameters=Object.assign({}, this.state.reportParameters);
  if (this.props.reportdefinition.maxRows)
      parameters.maxrows=this.props.reportdefinition.maxRows;
  
  invokeApig({path: "/smart/reports/"+this.props.reportdefinition.reportName, method: "POST", body:parameters}).catch(e=>{this.setState({reportData: [], reportLoading: false, errorMessage: "Unknown error running report",})}).then((result)=>
  {
   
    if (result.status===200)
    if (this.props.reportdefinition.maxRows && result.data.length===this.props.reportdefinition.maxRows)
      this.setState({reportData: result.data, reportLoading: false, errorMessage: "Data truncated - first " + this.props.reportdefinition.maxRows + " rows returned", errorDetail: []})
    else
      this.setState({reportData: result.data, reportLoading: false, errorMessage: null, errorDetail: []})
    else if (result.status===400)
    this.setState({reportData: [], reportLoading: false, errorMessage: "Error running report", errorDetail: result.data})
    else if (result.status===404)
    this.setState({reportData: [], reportLoading: false, errorMessage: "Report not found", errorDetail: []})  
    else if (result.status===504)
    this.setState({reportData: [], reportLoading: false, errorMessage: "Report timed out", errorDetail: []})  
    else 
    this.setState({reportData: [], reportLoading: false, errorMessage: "Unknown error running report", errorDetail: []})  


  })
}

connectivityImage=(connectivity)=>{
  if (connectivity==0)
  return 'no-connection-16.png'
  else if (connectivity==1)
  return 'poor-connection-16.png'
  else if (connectivity==2)
  return 'average-connection-16.png'
  else if (connectivity==3)
  return 'good-connection-16.png'
}
connectivityDescription=(connectivity)=>{
  if (connectivity==0)
  return 'None'
  else if (connectivity==1)
  return 'Poor'
  else if (connectivity==2)
  return 'Average'
  else if (connectivity==3)
  return 'Good'
}

healthCheckIcon=(healthcheckStatus)=>{
  if (healthcheckStatus==1)
  return 'check'
  else if (healthcheckStatus==2)
  return 'warning sign'
  else if (healthcheckStatus==3)
  return 'x'
}

healthCheckColour=(status)=>{
  if (status==1)
  return 'green'
  else if (status==2)
  return 'yellow'
  else if (status==3)
  return 'red'
}



validParameters=()=>{
  var valid=true;
  Object.keys(this.state.reportParameters).forEach(parameterName=>{
    if (!this.state.reportParameters[parameterName])
      valid=false;
  })
  return valid;

}

deleteParameter=(parameterName)=>{
  var copyData={...this.state.reportParameters};
  delete copyData[parameterName];
  this.setState({reportParameters: copyData})

}

addParameter=(parameterName)=>{
    this.setState({reportParameters: {...this.state.reportParameters, [parameterName]: null}})
}

exportReportToExcel=()=>
{
  var fieldNames;
  var columnHeaders;
  const filename= this.props.reportdefinition.reportName;
  const sheetname= this.props.reportdefinition.reportName

  if ('fields' in this.props.reportdefinition)
  {
    fieldNames=this.props.reportdefinition.fields.map(field=>{return field.fieldName});
    columnHeaders=this.props.reportdefinition.fields.map(field=>{return field.title});
  }
  else
  {
    fieldNames=Object.keys(this.state.reportData[0]);
    columnHeaders=Object.keys(this.state.reportData[0]);

  }

  exportToExcel(this.state.reportData, fieldNames, columnHeaders, filename, sheetname);

}

render() {

    const healthCheckCategoryDesciptions = {
      "schedule": "Schedule", "paymentmode": "Payment Mode", "primarytariff": "Tariff", "billingcalendar": "Billing Calendar", "suppliercertificates": "Supplier Certificates", "dnocertificates": "DNO Certificates", "devicecertificates": "Device Certificates", "loadlimitsetttings": "Load Limits", "instantaneouspowerthresholds": "Power Thresholds", "eventandalertbehaviours": "Alert Configuration", "devicewhitelist": "Device White List"
    }

    //handle pagination
    var activePage=this.state.activePage;
    var reportData=this.state.reportData;
    if (reportData.length<(activePage-1)*this.props.reportdefinition.pageSize)
    {
      activePage=1;
      this.setState({activePage: 1})
    }
    var pageData=reportData.slice((activePage-1)*this.props.reportdefinition.pageSize, activePage*this.props.reportdefinition.pageSize)
    
    return <div>
      <Header as='h3' className={this.state.darkmode ? "darkmode" : "seaglassblue"}><Icon name='file alternate outline'/>{this.props.reportdefinition.title}</Header>
      <Form inverted={this.state.darkmode}>
      <Form.Field><label style={{color: this.props.darkmode ? "white": "black"}}>Saved Report</label><Select value={this.state.savedReportName} options={this.state.savedReports.map(report=>{return {key: report.name, value: report.name, text: report.name}})} onChange={(event, data)=>{var report=this.state.savedReports.find(report=>{return report.name===data.value});this.setState({savedReportName: report.name, reportParameters: report.parameters})}}/></Form.Field>
      </Form>
      <Header as='h5' className={this.state.darkmode ? "darkmode" : "seaglassblue"}><Icon name='search'/>Criteria</Header>
      <Form inverted={this.state.darkmode}>
        {Object.keys(this.state.reportParameters).map(parameterName=>{
          const parameterDefinition=this.props.reportdefinition.parameters[parameterName];
          if ('values' in parameterDefinition) 
            return <Form.Field><label style={{color: this.props.darkmode ? "white": "black"}}>{parameterDefinition.label}{!parameterDefinition.required && <a onClick={()=>{this.deleteParameter(parameterName)}}> delete</a>}</label><Select placeholder={parameterDefinition.label} options={Object.keys(parameterDefinition.values).map(key=>{return {key: key, value: key, text: parameterDefinition.values[key]}})} value={this.state.reportParameters[parameterName]} onChange={(event, data)=>{this.setState({reportParameters: {...this.state.reportParameters, [parameterName]: data.value}}); }} /></Form.Field>
          else
            if (parameterDefinition.type==="date")
              return <Form.Field><label style={{color: this.props.darkmode ? "white": "black"}}>{parameterDefinition.label}{!parameterDefinition.required && <a onClick={()=>{this.deleteParameter(parameterName)}}> delete</a>}</label><Input  type="date" placeholder={parameterDefinition.label} value={this.state.reportParameters[parameterName]} onChange={(event, data)=>{this.setState({reportParameters: {...this.state.reportParameters, [parameterName]: data.value}}); }} /></Form.Field>
            else
              return <Form.Field><label style={{color: this.props.darkmode ? "white": "black"}}>{parameterDefinition.label}{!parameterDefinition.required && <a onClick={()=>{this.deleteParameter(parameterName)}}> delete</a>}</label><Input placeholder={parameterDefinition.label} value={this.state.reportParameters[parameterName]} onChange={(event, data)=>{this.setState({reportParameters: {...this.state.reportParameters, [parameterName]: data.value}}); }} /></Form.Field>

        })}
        <Form.Dropdown text='Add new...'>
        <Dropdown.Menu  style={{color: "black"}}>
        {Object.keys(this.props.reportdefinition.parameters).filter(parameterName=>{return !(parameterName in this.state.reportParameters)}).map(parameterName=>{return <Dropdown.Item onClick={()=>{this.addParameter(parameterName)}} text={this.props.reportdefinition.parameters[parameterName].label}/>})}
        </Dropdown.Menu>
        </Form.Dropdown>
        <Button className='seaglassbutton' disabled={!this.validParameters()} onClick={()=>{this.setState({showSaveModal: true})}}><Icon name='save'/>Save Report</Button>
        <Button className='seaglassbutton' disabled={!this.validParameters()} onClick={()=>{this.loadReportData()}}><Icon name='play'/>Run</Button>
        <Button className="seaglassbutton" onClick={()=>{this.exportReportToExcel()}}><Icon name='file excel outline'/>Export to Excel</Button>
      </Form>
      {(!this.state.reportLoading) ? <div>
      <Divider/>
      {this.state.errorMessage && <Message error header={this.state.errorMessage} list={this.state.errorDetail}/>}
      <Header as='h5' className={this.state.darkmode ? "darkmode" : "seaglassblue"}><Icon name='list'/>Results</Header>
      <Table>
        <Table.Header>
        <Table.Row>
          {'fields' in this.props.reportdefinition ? this.props.reportdefinition.fields.map(field=>{return <Table.HeaderCell>{field.title}</Table.HeaderCell>}) : this.state.reportData.length> 0 && Object.keys(this.state.reportData[0]).map(fieldName=>{return <Table.HeaderCell>{fieldName}</Table.HeaderCell>})}
        </Table.Row>
        </Table.Header>
        <Table.Body>  
        {reportData.map(row=>{
          return <Table.Row>
            {'fields' in this.props.reportdefinition ? this.props.reportdefinition.fields.map(field=>{
              if (field.type==="text")
                if ('values' in field)
                  return <Table.Cell>{field.values[row[field.fieldName]]}</Table.Cell>
                else
                  return <Table.Cell>{row[field.fieldName]}</Table.Cell>
              else if (field.type==="date")
              return <Table.Cell>{row[field.fieldName] ? formatDate(new Date(row[field.fieldName])) : ""}</Table.Cell>
              else if (field.type==="deviceid")
                return <Table.Cell><Link to={'../smartdevice/'+row[field.fieldName]}>{row[field.fieldName]}</Link></Table.Cell>
              else if (field.type==="connectivity")
                return <Table.Cell textAlign='center'>{row[field.fieldName] ? <img src={require('../images/'+this.connectivityImage(row[field.fieldName]))}/> : null}</Table.Cell>
              else if (field.type==="healthcheck")
                return <Table.Cell textAlign='center'><Icon size='large' name={this.healthCheckIcon(row[field.fieldName])} color={this.healthCheckColour(row[field.fieldName])}/></Table.Cell>
              else if (field.type==="healthcheckdata" && row[field.fieldName])
              {
                const healthCheckData=JSON.parse(row[field.fieldName]);
                return <Table.Cell><List>{Object.keys(healthCheckData).map(key=>{return <List.Item>{healthCheckCategoryDesciptions[key]+" - "+healthCheckData[key]}</List.Item>})}</List></Table.Cell>
              }

              }) : Object.keys(row).map(fieldName=>{return <Table.Cell>{row[fieldName]}</Table.Cell>})}

            </Table.Row>
        })}
        </Table.Body>
        </Table>
        <Pagination activePage={this.state.activePage} totalPages={Math.ceil(this.state.reportData.length/this.props.reportdefinition.pageSize)} onPageChange={(event, { activePage })=>{this.setState({activePage: activePage})}}/>
        </div>: <LoadingPage/>}
        <Modal open={this.state.showSaveModal}>
        <Modal.Header size='tiny'>
          <h3 className="seaglassblue"><Icon circular className="seaglassblue" name="add" onClick={this.addNewPolicy}/>Save Report Definition</h3>
        </Modal.Header>  
        <Modal.Content>
        <Form>
        <Form.Input label="Report Name" value={this.state.savedReportName} onChange={(event, data)=>this.setState({savedReportName: data.value})}/>

        <Button className='seaglassbutton' onClick={()=>{this.saveReport()}}>Save</Button>
        <Button className="seaglassbutton" onClick={()=>{this.setState({showSaveModal: false})}}>Close</Button>
        </Form>
        </Modal.Content>
        </Modal>    
      </div>

   }
}
